import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const organizations = ['Pumo Tech', 'Monz-Creativeschool'];

// react-select styles
const selectStyles = {
    control: (base, state) => ({
        ...base,
        border: '1px solid #ddd',
        borderRadius: '4px',
        boxShadow: state.isFocused ? '0 0 0 1px #474556' : 'none',
        borderColor: state.isFocused ? '#474556' : '#ddd',
        fontFamily: "'Times New Roman', Times, serif",
        fontSize: '14px',
        minHeight: '42px',
        '&:hover': { borderColor: '#474556' },
    }),
    menu: (base) => ({
        ...base,
        fontFamily: "'Times New Roman', Times, serif",
        fontSize: '14px',
        zIndex: 9999,
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? '#474556'
            : state.isFocused
                ? '#f3f4f6'
                : 'white',
        color: state.isSelected ? 'white' : '#333',
        cursor: 'pointer',
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: '#ede9fe',
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: '#312f44',
        fontSize: '13px',
        fontWeight: '600',
    }),
    multiValueRemove: (base) => ({
        ...base,
        color: '#474556',
        '&:hover': { backgroundColor: '#474556', color: 'white' },
    }),
};

// helpers
const toOptions = (arr = []) =>
    arr.map((item) => ({ value: item, label: item }));

const fromOptions = (selected) =>
    selected ? selected.map((opt) => opt.value) : [];

const EmployeeDetailsModal = ({
    formData,
    availableLocations,
    availableBranches,
    onInputChange,
    onSave,
    onClose,
}) => {

    const [departmentOptions, setDepartmentOptions] = useState([]);

    // 🔥 Fetch departments from API
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/alltech`);
                const data = await res.json();

                const uniqueDepartments = [
                    ...new Set(data.data.map(item => item.Department))
                ];

                setDepartmentOptions(uniqueDepartments);
            } catch (err) {
                console.error("Failed to fetch departments:", err);
            }
        };

        fetchDepartments();
    }, []);

    const fireChange = (name, value) => {
        onInputChange({ target: { name, value } });
    };

    // handlers
    const handleOrganizationChange = (selected) =>
        fireChange('organization', fromOptions(selected));

    const handleDepartmentChange = (selected) =>
        fireChange('Department', fromOptions(selected));

    const handleLocationChange = (selected) =>
        fireChange('location', fromOptions(selected));

    const handleBranchChange = (selected) =>
        fireChange('branch', fromOptions(selected));

    return (
        <div className="modalve-overlay">
            <div className="employee-details-modal">
                <div className="modal-header">
                    <h2>Edit Employee</h2>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                <div className="modalve-content">
                    <div className="edit-form">

                        {/* Name */}
                        <div className="form-group">
                            <label>Employee Name *</label>
                            <input
                                type="text"
                                name="emp_name"
                                value={formData.emp_name || ''}
                                readOnly
                                style={{ backgroundColor: '#f5f5f5' }}
                            />
                        </div>

                        {/* Email */}
                        <div className="form-group">
                            <label>Email ID *</label>
                            <input
                                type="email"
                                name="email_id"
                                value={formData.email_id || ''}
                                onChange={onInputChange}
                            />
                        </div>

                        {/* Role */}
                        <div className="form-group">
                            <label>Role *</label>
                            <select
                                name="role"
                                value={formData.role || ''}
                                onChange={onInputChange}
                            >
                                <option value="BDE">BDE</option>
                                <option value="Trainer">Trainer</option>
                                <option value="Branch-head">Branch-Head</option>
                                <option value="Placement officer">Placement officer</option>
                            </select>
                        </div>

                        {/* Organization */}
                        <div className="form-group">
                            <label>Organization *</label>
                            <Select
                                isMulti
                                options={toOptions(organizations)}
                                value={toOptions(formData.organization || [])}
                                onChange={handleOrganizationChange}
                                styles={selectStyles}
                                closeMenuOnSelect={false}
                            />
                        </div>

                        {/* 🔥 Department (NEW) */}
                        <div className="form-group">
                            <label>Department *</label>
                            <Select
                                isMulti
                                options={toOptions(departmentOptions)}
                                value={toOptions(formData.Department || [])}
                                onChange={handleDepartmentChange}
                                placeholder="Select Departments"
                                styles={selectStyles}
                                closeMenuOnSelect={false}
                            />
                        </div>

                        {/* Location */}
                        <div className="form-group">
                            <label>Location *</label>
                            <Select
                                isMulti
                                options={toOptions(availableLocations)}
                                value={toOptions(formData.location || [])}
                                onChange={handleLocationChange}
                                styles={selectStyles}
                                closeMenuOnSelect={false}
                            />
                        </div>

                        {/* Branch */}
                        <div className="form-group">
                            <label>Branch *</label>
                            <Select
                                isMulti
                                options={toOptions(availableBranches)}
                                value={toOptions(formData.branch || [])}
                                onChange={handleBranchChange}
                                styles={selectStyles}
                                closeMenuOnSelect={false}
                            />
                        </div>

                        {/* Contact */}
                        <div className="form-group">
                            <label>Contact Number *</label>
                            <input
                                type="text"
                                name="contact_num"
                                value={formData.contact_num || ''}
                                onChange={onInputChange}
                            />
                        </div>

                        {/* Alt Contact */}
                        <div className="form-group">
                            <label>Alternative Contact</label>
                            <input
                                type="text"
                                name="alter_contact"
                                value={formData.alter_contact || ''}
                                onChange={onInputChange}
                            />
                        </div>

                        {/* Address */}
                        <div className="form-group">
                            <label>Address</label>
                            <input
                                type="text"
                                name="address"
                                value={formData.address || ''}
                                onChange={onInputChange}
                            />
                        </div>
                        

                        {/* Buttons */}
                        <div className="form-actions">
                            <button className="btn-cancel" onClick={onClose}>
                                Cancel
                            </button>
                            <button className="btn-save" onClick={onSave}>
                                Save Changes
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeDetailsModal;